import { Component, Input, OnInit, inject } from '@angular/core';
import { pupilModel } from '@exclusionmodule/models';
import { STUDENT_ENDPOINT } from '@shared/properties';
import { ApiServiceService, NotificationService } from '@oneeducation/app-core';

@Component({
  selector: 'app-academic-summary-view',
  templateUrl: './academic-summary-view.component.html',
  styleUrls: ['./academic-summary-view.component.scss'],
  standalone: false
})
export class AcademicSummaryViewComponent implements OnInit {
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);

  @Input() pupilData: any;
  @Input() schoolId: any;
  pupil: pupilModel;

  daysThisTerm: number;
  daysThisAcademicYear: number;

  ngOnInit() {
    this.getAcademicYearDetails();
  }

  getAcademicYearDetails() {
    const apiRoute = this.getApiRoute(this.pupilData.studentId, this.schoolId);
    this.apiService.get<any>(apiRoute, '').subscribe({
      next: (x: any) => {
        if (parseInt(x.statusCode) === 200) {
          this.daysThisTerm = this.handleNullForAcademicYear(
            x.student.excludedDaysInCurrentTerm
          );
          this.daysThisAcademicYear = this.handleNullForAcademicYear(
            x.student.excludedDaysInCurrentYear
          );
        } else {
          this.assignDefaultExclusionCount();
          this.showErrorMessage();
        }
      },
      error: () => {
        this.assignDefaultExclusionCount();
        this.showErrorMessage();
      }
    });
  }

  private assignDefaultExclusionCount() {
    this.daysThisTerm = 0;
    this.daysThisAcademicYear = 0;
  }

  private handleNullForAcademicYear(exclusionCount: any) {
    if (exclusionCount == null || exclusionCount == undefined) {
      return 0;
    }

    return exclusionCount;
  }

  private showErrorMessage() {
    this.notificationService.showError(
      'Something went wrong while displaying number of days excluded for the pupil, please try again.'
    );
  }

  private getApiRoute(studentId: number, schoolId: number) {
    return STUDENT_ENDPOINT.GetStudentSummary.replace(
      '{studentId}',
      studentId.toString()
    ).replace('{schoolId}', schoolId.toString());
  }
}
